// Centralized site data: navigation, submenus, contact info, brand strings.

// While the site is in compliance review, hide all customer data-collection
// surfaces (login, chat widget, request forms, cookie consent popup) and
// replace forms with direct call/email CTAs. Flip to `false` to restore.
export const COMPLIANCE_MODE = true;

export type SubLink = { label: string; href: string };
export type NavItem = { label: string; href: string; submenu?: SubLink[] };

export const PRIMARY_NAV: NavItem[] = [
  {
    label: "Oakland",
    href: "/oakland",
    submenu: [
      { label: "Residential Recycling", href: "/oakland#residential" },
      { label: "Multifamily & Property Recycling", href: "/oakland#multifamily" },
      { label: "Used Oil, Oil Filters & Batteries", href: "/oakland#used-oil" },
      { label: "Recycle Cart & Container Help", href: "/oakland#cart-help" },
      { label: "Report Missed Pickup", href: "/oakland#missed-pickup" },
      { label: "Oakland Recycling Guide", href: "/recycling-guide#oakland" },
      { label: "Commercial Recycling in Oakland", href: "/oakland#commercial" },
      { label: "Oakland Support", href: "/oakland#oakland-customer-support" },
    ],
  },
  {
    label: "San José",
    href: "/san-jose",
    submenu: [
      { label: "Residential Recycling", href: "/san-jose#residential" },
      { label: "Service Area & Schedule Lookup", href: "/san-jose#service-area" },
      { label: "Used Oil & Oil Filters", href: "/san-jose#used-oil" },
      { label: "Junk Pickup", href: "/san-jose/junk-pickup" },
      { label: "Cart & Container Help", href: "/san-jose#cart-help" },
      { label: "Report Missed Pickup", href: "/san-jose#missed-pickup" },
      { label: "San José Recycling Guide", href: "/recycling-guide#san-jose" },
      { label: "San José Support", href: "/san-jose#san-jose-customer-support" },
    ],
  },
  {
    label: "Commercial",
    href: "/commercial",
    submenu: [
      { label: "Commercial Recycling Services", href: "/commercial" },
      { label: "Request a Quote", href: "/commercial#quote" },
      { label: "Pay Commercial Invoice", href: "/pay-commercial-invoice" },
      { label: "Business Recycling", href: "/commercial" },
      { label: "Property Managers", href: "/commercial" },
      { label: "Multi-Tenant Properties", href: "/commercial" },
      { label: "Service Support", href: "/contact#commercial" },
    ],
  },
  {
    label: "Recycling Guide",
    href: "/recycling-guide",
    submenu: [
      { label: "What Goes in Recycling", href: "/recycling-guide#in" },
      { label: "Used Oil, Batteries & Hazardous Waste", href: "/recycling-guide#hazardous" },
      { label: "Oakland Recycling Guide", href: "/recycling-guide#oakland" },
      { label: "San José Recycling Guide", href: "/recycling-guide#san-jose" },
      { label: "Tips For Recycling", href: "/recycling-guide#tips" },
      { label: "FAQs", href: "/faqs" },
    ],
  },
  {
    label: "Sustainability",
    href: "/sustainability",
    submenu: [
      { label: "Sustainability Overview", href: "/sustainability#overview" },
      { label: "ESG In Practice", href: "/sustainability#esg" },
      { label: "Community Education & Outreach", href: "/sustainability#education" },
    ],
  },
  {
    label: "About",
    href: "/about",
    submenu: [
      { label: "Our Story", href: "/about#story" },
      { label: "Vietnam Operations", href: "/about#vietnam" },
      { label: "Leadership", href: "/leadership" },
      { label: "Governance & Compliance", href: "/governance" },
      { label: "Careers", href: "/careers" },
    ],
  },
  {
    label: "News",
    href: "/news",
    submenu: [
      { label: "Newsroom & Press Room", href: "/newsroom" },
      { label: "Media Coverage", href: "/newsroom/media-coverage" },
      { label: "Company News", href: "/news" },
      { label: "Service Updates", href: "/news" },
      { label: "Community Updates", href: "/news" },
      { label: "Press Releases", href: "/news" },
      { label: "Recycling Education", href: "/news" },
    ],
  },
  {
    label: "Contact",
    href: "/contact",
    submenu: [
      { label: "Oakland Support", href: "/contact#oakland" },
      { label: "San José Support", href: "/contact#san-jose" },
      { label: "Commercial Quote", href: "/contact#commercial" },
      { label: "Sales / Media / Partnerships", href: "/contact#other" },
      { label: "FAQs", href: "/contact#faqs" },
      { label: "Our Locations", href: "/contact#locations" },
    ],
  },
];

export const OAKLAND_CONTACT = {
  name: "Oakland Customer Care",
  phone: "(510) 625-5263",
  email: "OaklandCS@calwaste.com",
  hq: "1211 Embarcadero, Suite 300, Oakland, CA 94606",
  ops: "1820 10th Street, Oakland, CA 94607",
};

export const SAN_JOSE_CONTACT = {
  name: "San José Customer Care",
  phone: "(408) 213-7800",
  email: "customerservice@calwaste.com",
  office: "1120 Berryessa Road, San José, CA 95133",
  ops: "1005 Timothy Drive, San José, CA 95133",
};

export const VIETNAM_CONTACT = {
  name: "Vietnam Waste Solutions",
  facility: "Đường Liên Ấp 1-2, Ấp 1, Xã Hưng Long, Thành phố Hồ Chí Minh, Việt Nam",
  headOffice: "42 Lý Văn Phức, Phường Tân Định, Thành Phố Hồ Chí Minh, Việt Nam",
  phones: ["+84 (028) 3778 0588", "+84 (028) 3778 0589"],
  email: "vws@vnwaste.com",
  websites: ["vnwaste.com", "vietnamwastesolutions.com"],
};

export const GENERAL_INQUIRY_EMAIL = "info@calwaste.com";
